<template>
  <div class="Form-inputGroup" :class="{ 'Form-inputGroup--error': validations ? validations.$error : false }">
    <label class="Form-label" v-bind:for="computedDefinition.id">{{ computedDefinition.label }}</label>
    <div class="Input" :class="computedDefinition.class">
      <input
        v-if="computedDefinition.fieldType == 'text' || computedDefinition.fieldType == 'password'"
        class="Input-field"
        ref="computedDefinition.id"
        v-bind:type="computedDefinition.fieldType"
        v-bind:id="computedDefinition.id"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-on:blur="$emit('blur'+computedDefinition.id, $event.target.value)"
      />
      <number-input
        v-if="computedDefinition.fieldType == 'number'"
        class="NumberInput"
        center
        size="large"
        :disabled="computedDefinition.disabled"
        :readonly="computedDefinition.disabled"
        :controls="!computedDefinition.disabled"
        :min="computedDefinition.numberMin"
        ref="computedDefinition.id"
        v-bind:id="computedDefinition.id"
        v-bind:value="value > 0 ? value : 0"
        v-on:change="NumberInputChanged($event)"
      ></number-input>
      <type-ahead
        v-if="computedDefinition.fieldType == 'typeahead'"
        v-bind:id="computedDefinition.id"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-on:blur="typeaheadChanged($event); $emit('blur'+computedDefinition.id, $event);"
        v-on:selectedItem="typeaheadSelection($event)"
        v-on:change="updateTypeaheadSearch($event)"
        :searchUrl="computedDefinition.url"
      ></type-ahead>
    </div>
  </div>
</template>

<script>
import './_Input.scss';

import NumberInput from '@chenfengyuan/vue-number-input';
import TypeAhead from "../type-ahead/type-ahead.vue";

export default {
  components: {
    NumberInput,
    TypeAhead,
  },
  props: {
    validations: Object,
    definition: {
      type: Object,
      default: function () {
        return {
          id: 'field',
          label: 'Field*',
          class: '',
          fieldType: 'text',
          numberMin: 1,
          disabled: false,
        }
      }
    },
    value: [String, Number, Object, Boolean],
    fieldType: [String]
  },
  computed: {
    computedDefinition() {
      return Object.assign({
        id: 'field',
        label: 'Field*',
        class: '',
        fieldType: this.definition.fieldType ? this.definition.fieldType : 'text',
        numberMin: 1,
        disabled: false,
        url: '',
      }, this.definition)
    }
  },
  methods: {
    NumberInputChanged: function (newValue) {
      this.$emit('change', newValue);
    },
    typeaheadChanged: function (newValue) {
      this.$emit('change', newValue);
    },
    typeaheadSelection: function (newValue) {
      this.$emit('selected', newValue);
    },
    updateTypeaheadSearch: function(newValue) {
      this.$emit('change', newValue.target.value);
    }
  },
  data: function () {
    return {}
  }
}
</script>
